"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var customValidators = _interopRequireWildcard(require("./customValidators"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var valueFields = {
  Checkbox: {
    valuePropName: 'checked',
    initialValue: false
  },
  RadioGroup: {
    initialValue: null
  },
  Datepicker: {
    initialValue: null
  },
  Select: {
    initialValue: undefined
  },
  TreeSelect: {
    initialValue: undefined
  },
  MaskedInput: {
    getValueFromEvent: function getValueFromEvent(e) {
      // TODO: iban input default value on blur da validate olmuyor!
      return e.target.getAttribute('unmaskedValue');
    }
  },
  CurrencyInput: {
    getValueFromEvent: function getValueFromEvent(e, unmask, mask) {
      return unmask;
    }
  },
  EmailInput: {
    rules: [{
      type: 'email'
    }]
  },
  CheckboxGroup: {
    initialValue: []
  },
  Switch: {
    valuePropName: 'checked',
    initialValue: false
  }
};
var Rules = /*#__PURE__*/function () {
  function Rules() {
    (0, _classCallCheck2.default)(this, Rules);
    this.validator = {
      initialValue: '',
      rules: [],
      validateFirst: false
    };
    this.rules = {};
  }
  return (0, _createClass2.default)(Rules, [{
    key: "getRules",
    value: function getRules(componentProps, displayName) {
      var _this = this;
      var initialValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      // if (displayName === 'Radio')
      //   valueFields[displayName]._value = componentProps.value;
      this.validator.initialValue = initialValue;
      if (valueFields[displayName]) {
        this.validator = _objectSpread(_objectSpread({}, this.validator), valueFields[displayName]);
      }
      if (componentProps.validationOptions) this.validator = _objectSpread(_objectSpread({}, this.validator), componentProps.validationOptions);
      var validateTrigger = this.validator.validateTrigger;
      if (validateTrigger) {
        [].concat(validateTrigger).forEach(function (eventType) {
          if (componentProps[eventType]) {
            _this.validator[eventType] = componentProps[eventType];
          }
        });
      }

      // pass component onChange handler to form
      if (componentProps.onChange) this.validator.onChange = componentProps.onChange;
      if (componentProps.mask && displayName !== 'CurrencyInput') {
        this.validator = _objectSpread(_objectSpread({}, this.validator), valueFields['MaskedInput']);
      }
      if (valueFields[displayName] && valueFields[displayName].rules) {
        var controlValidation = [];
        if (componentProps.validation) {
          controlValidation = componentProps.validation;
        }
        this.validator.rules = (0, _toConsumableArray2.default)(controlValidation);
        valueFields[displayName].rules.forEach(function (rule) {
          var hasSameRule = _this.validator.rules.some(function (innerRule) {
            return rule.type === innerRule.type;
          });
          if (!hasSameRule) {
            _this.validator.rules.push(rule);
          }
        });
      } else {
        /** If requested validator type is in customValidators */
        var customValidator = customValidators[componentProps.type];
        this.validator.rules = componentProps.validation;
        if (customValidator) {
          this.validator.rules.push({
            validator: function validator(rule, value, callback) {
              return customValidator(rule, value, callback, componentProps.validation);
            }
          });
        }
      }
      return this.validator;
    }
  }]);
}();
var _default = exports.default = Rules;